import { BEPlayerStatsItem } from '@/lib/network';

export const CATEGORY_COLUMNS: Array<{
  key: string;
  label: string;
  field: keyof BEPlayerStatsItem;
}> = [
  { key: 'goals', label: 'GOALS', field: 'goals' },
  { key: 'assists', label: 'ASSISTS', field: 'assists' },
  { key: 'cs', label: 'CLEAN SHEETS', field: 'cleanSheet' },
  { key: 'shotsOnTarget', label: 'SHOTS ON TARGET', field: 'shotsOnTarget' },
  { key: 'chancesCreated', label: 'BIG CHANCES CREATED', field: 'chancesCreated' },
  { key: 'tackles', label: 'TACKLES', field: 'tackles' },
  { key: 'saves', label: 'SAVES', field: 'saves' },
  { key: 'goalsConceded', label: 'GOALS CONCEDED', field: 'goalsConceded' },
  { key: 'ownGoals', label: 'OWN GOALS', field: 'ownGoals' },
  { key: 'yellowCards', label: 'YELLOW CARDS', field: 'yellowCards' },
  { key: 'redCards', label: 'RED CARDS', field: 'redCards' },
  { key: 'penaltyMisses', label: 'PENALTY MISSES', field: 'penaltyMisses' },
  { key: 'penaltySaves', label: 'PENALTY SAVES', field: 'penaltySaves' },
];

export const PPM_COLUMNS: Array<{ key: string; label: string; field: keyof BEPlayerStatsItem }> = [
  { key: 'dribble', label: 'DRIBBLES', field: 'dribbles' },
  { key: 'cross', label: 'CROSSES', field: 'crosses' },
  { key: 'offside', label: 'OFFSIDES', field: 'offsides' },
  { key: 'passCompletion', label: 'PASS %', field: 'passCompletionRate' },
  { key: 'interception', label: 'INTERCEPTIONS', field: 'interceptions' },
  { key: 'block', label: 'BLOCKS', field: 'blocks' },
  { key: 'goalOutside', label: 'GOALS OUTSIDE', field: 'goalsOutsideArea' },
  { key: 'foulWon', label: 'FOULS WON', field: 'foulsWon' },
  { key: 'foulConceded', label: 'FOULS MADE', field: 'foulsMade' },
  { key: 'errorToGoal', label: 'ERRORS→GOAL', field: 'errorsLeadingToGoal' },
  { key: 'claim', label: 'CLAIMS', field: 'claims' },
  { key: 'punch', label: 'PUNCHES', field: 'punches' },
  { key: 'keeperSweep', label: 'K. SWEEPS', field: 'keeperSweeps' },
];

/** The one column whose header is named after the competition's scoring period. */
export const PERIOD_POINTS_COLUMN_KEY = 'gwPts';

export const STATS_COLUMNS: Array<{ key: string; label: string; field: keyof BEPlayerStatsItem }> =
  [
    { key: 'price', label: 'PRICE', field: 'price' },
    { key: 'percentSelected', label: '% SEL', field: 'percentSelected' },
    // Header resolved at render from the active tournament — see PERIOD_POINTS_COLUMN_KEY.
    { key: PERIOD_POINTS_COLUMN_KEY, label: '', field: 'gameweekPoints' },
    // Always on, and next to the period points so the default sort (see `sort` state)
    // reads against a visible column.
    { key: 'pts', label: 'TOTAL PTS', field: 'totalPoints' },
    { key: 'avgPts', label: 'AVG PTS', field: 'averagePoints' },
    { key: 'last3Avg', label: 'LAST 3', field: 'last3Average' },
    { key: 'bonusPoints', label: 'BONUS PTS', field: 'bonusPoints' },
    { key: 'ppmPoints', label: 'PPM', field: 'ppmPoints' },
  ];
